/**
 * The Astryx theme for the landing site.
 *
 * The same brand as the product's theme (hireos-intake `shared/theme/hireos.ts`)
 * — deep green #3B6B52, warm neutrals, Hanken Grotesk — trimmed to what this
 * site actually renders. The product's copy also themes `top-nav`, `tooltip`,
 * `switch-thumb` and the dropdowns; there is no operator chrome here, so those
 * overrides would be rules about components that never mount.
 *
 * What it is for: the tokens. Astryx injects them as custom properties at
 * runtime, which is what makes an Astryx component dropped in later look like
 * the rest of the product without a second palette. The page's own look lives
 * in src/styles.css and is deliberately not the product's design system — see
 * the header of that file.
 *
 * If this drifts from the product's theme, the product's is right.
 */
import { defineTheme } from "@astryxdesign/core/theme";

// The page loads Hanken Grotesk as "Hanken Grotesk Variable" (public/fonts.css),
// so that name comes first after the product's, or text falls to system-ui.
const FONT_FALLBACKS =
  "'Hanken Grotesk Variable', 'Geist Sans', system-ui, -apple-system, sans-serif";

export const hireosTheme = defineTheme({
  name: "hireos",
  color: { accent: "#3B6B52", neutralStyle: "warm" },
  typography: {
    body: { family: "Hanken Grotesk", fallbacks: FONT_FALLBACKS },
    heading: { family: "Hanken Grotesk", fallbacks: FONT_FALLBACKS },
  },
  radius: { base: 6, multiplier: 0.75 },
  tokens: {
    "--color-accent": ["#3B6B52", "#6F987E"],
    // Separation comes from borders, never elevation.
    "--shadow-low": "none",
    "--shadow-med": "none",
    "--shadow-high": "none",
    "--shadow-inset-hover": "none",
    // Nothing rests in a state that looks hovered.
    "--color-overlay-hover": ["transparent", "transparent"],
    "--color-background-surface": "#ffffff",
  },
  components: {
    button: {
      base: { "--button-press-scale": "none" },
    },
  },
});
